import { cloneDeep } from 'lodash'
import { initialState } from '../initialState'
import { imageActions as actions } from '../actions'
import { createReducer, methodSwitcher } from './utilities'

const { image } = initialState

const clearCurrent = state => ({ ...state, current: {} })

const setImageList = (state, { data }) => {
  const newState = cloneDeep(state)
  newState.list = data
  return newState
}

const setCurrentImage = (state, { data }) => {
  const newState = cloneDeep(state)
  newState.current = data
  return newState
}

const actionImage = (state, { data, id, method }) => {
  const newState = cloneDeep(state)
  methodSwitcher(newState, data, id, method)
  return newState
}

export const imageReducer = createReducer(image, {
  [actions.LIST]: setImageList,
  [actions.CLEAR_CURRENT]: clearCurrent,
  [actions.CURRENT]: setCurrentImage,
  [actions.CUD]: actionImage
})
